// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"332":"28069b3d","354":"793392bc","953":"824527cd"}[chunkId] + ".js";
};